/* eslint-disable @typescript-eslint/naming-convention */
import { IFormItemProps } from '@/components';
import { BotDataManagerType, HomeDataStyle } from '@/const/promotion';
import { ManageBotSelectOptions, ManageStyleOptions } from '@/pages/promotion/info/custom-form/custom-index/config';
import { fetchSpaceOptions } from '@/pages/space/fetch/fetchSpace-config';

import { validateBots } from '../validate';

export const formStyle: { [key: string]: HomeDataStyle } = {
  [BotDataManagerType.BOTDATAMANAGERTYPE_BANNER]: HomeDataStyle.HOMEDATASTYLE_BANNER,
  [BotDataManagerType.BOTDATAMANAGERTYPE_COLLECTION]: HomeDataStyle.HOMEDATASTYLE_HORIZONTAL_SLIDE,
  [BotDataManagerType.BOTDATAMANAGERTYPE_ACCORDION]: HomeDataStyle.HOMEDATASTYLE_BANNER,
  [BotDataManagerType.BOTDATAMANAGERTYPE_RECENT_VISIT]: HomeDataStyle.HOMEDATASTYLE_VERTICAL_SLIDE,
};

export const commonBotCard: IFormItemProps[] = [
  {
    props: 'id',
    label: '唯一ID：（id）',
    render: 'hidden',
    uiOptions: {
      disabled: true,
    },
  },
  {
    props: 'managerType',
    label: '配置类型',
    render: 'debounceSelect',
    rules: [{ required: true, message: '请选择配置类型' }],
    uiOptions: {
      fetchOptions: async () => ({
        list: ManageBotSelectOptions,
      }),
    },
  },
  {
    props: 'style',
    label: '样式类型',
    render: 'hidden',
    useFormData: true,
    uiOptions: {
      useFormData: true,
      fetchOptions: async () => ({
        list: ManageStyleOptions,
      }),
    },
  },
  {
    props: 'bots',
    label: '选择角色',
    render: 'customBots',
    rules: [
      { required: true, message: '请选择角色' },
      { validator: e => validateBots(e, true) },
    ],
  },
];

export const collection: IFormItemProps[] = [
  {
    props: 'id',
    label: '唯一ID：（id）',
    render: 'hidden',
    uiOptions: {
      disabled: true,
    },
  },
  {
    props: 'managerType',
    label: '配置类型',
    render: 'debounceSelect',
    rules: [{ required: true, message: '请选择配置类型' }],
    uiOptions: {
      fetchOptions: async () => ({
        list: ManageBotSelectOptions,
      }),
    },
  },
  {
    props: 'name',
    label: '合集名称',
    render: 'input',
    rules: [{ required: true, message: '请输入合集名称' }],
    uiOptions: {
    },
  },
  {
    props: 'intro',
    label: '合集简介',
    render: 'input',
    rules: [{ required: true, message: '请输入合集简介' }],
    uiOptions: {
    },
  },
  {
    props: 'bots',
    label: '选择角色',
    render: 'customBots',
    rules: [
      { required: true, message: '请选择角色' },
      { validator: e => validateBots(e, false) },
    ],
  },
];

export const botCollection: IFormItemProps[] = [
  {
    props: 'id',
    label: '唯一ID：（id）',
    render: 'hidden',
    uiOptions: {
      disabled: true,
    },
  },
  {
    props: 'managerType',
    label: '配置类型',
    render: 'debounceSelect',
    rules: [{ required: true, message: '请选择配置类型' }],
    uiOptions: {
      fetchOptions: async () => ({
        list: ManageBotSelectOptions,
      }),
    },
  },
  {
    props: 'space',
    label: '合集类型',
    render: 'debounceSelect',
    uiOptions: {
      openUpdateOptions: true,
      hasDefault: true,
      valueType: 'object',
      fetchOptions: fetchSpaceOptions,
    },
    rules: [{ required: true, message: '请选择合集' }],
  },
  {
    props: 'bots',
    label: '选择角色',
    render: 'customBots',
    rules: [
      { required: true, message: '请选择角色' },
      { validator: e => validateBots(e, false) },
    ],
  },
];

export const recent: IFormItemProps[] = [
  {
    props: 'id',
    label: '唯一ID：（id）',
    render: 'hidden',
    uiOptions: {
      disabled: true,
    },
  },
  {
    props: 'managerType',
    label: '配置类型',
    render: 'debounceSelect',
    rules: [{ required: true, message: '请选择配置类型' }],
    uiOptions: {
      fetchOptions: async () => ({
        list: ManageBotSelectOptions,
      }),
    },
  },
];

export const botFormConfig: { [key: string]: IFormItemProps[] } = {
  [BotDataManagerType.BOTDATAMANAGERTYPE_BANNER]: commonBotCard,
  [BotDataManagerType.BOTDATAMANAGERTYPE_COLLECTION]: collection,
  [BotDataManagerType.BOTDATAMANAGERTYPE_ACCORDION]: botCollection,
  [BotDataManagerType.BOTDATAMANAGERTYPE_RECENT_VISIT]: recent,
};
